var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMountainSeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 55,
    viewBox: "0 0 64 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9851 0L-27 55H-2.82058L22.1682 25.4938L28.8839 32.1058L43.9851 0Z",
    fill: "#9AD1DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0007 13.6025L60.3193 23.921L43.9785 0L62.3391 36.0016L72.0007 13.5953V13.6025Z",
    fill: "#488A98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountainSeb);
export default __webpack_public_path__ + "static/media/mountain_SEB.bd3d1f5c326634cd7dd14b4a668d4735.svg";
export { ForwardRef as ReactComponent };